module.exports = __webpack_public_path__ + "static/media/gitHub.0918d786.png";